<div mat-dialog-title>
  <span>{{data.title?data.title:'Colors'}}</span>
</div>
<div mat-dialog-content>
  <div class="colors-container" style="margin-top: 1rem">
    <mat-icon
      *ngFor="let c of mainColors"
      [mat-dialog-close]="c.value"
      [style]="{
            color: c.value
          }"
      >circle</mat-icon
    >
    <mat-icon
      *ngFor="let c of data.colors"
      [mat-dialog-close]="c.value"
      matSuffix
      [style]="{
                color: c.value
              }"
      >circle</mat-icon
    >
  </div>
</div>
